import { Indicator } from '../../../Common/Charts/Indicator';
import { useAttentionChartsDataContext } from './hooks/useAttentionChartsDataContext';

export const WeightLess25KgxMothersLessThan6PrenatalConsultations = () => {
    const { chartData } = useAttentionChartsDataContext();

    return (
        <Indicator
            title={'Peso Menor de 25Kg x Menos com menos de 6 Consultas Pré-Natal'}
            indicatorValue={chartData?.indicators?.weightLess25KgxMothersLessThan6PrenatalConsultations}
            className='aligned-container'
        />
    );
};
